$(function() {
    $('.faq-trigger').on('click', function(e){
        e.preventDefault();

        let thisFaq = $(this).closest('.faq');

        if(thisFaq.hasClass('open')) {
            thisFaq.closeFaq();
        } else {
            thisFaq.openFaq();
        }
    })

    $.fn.openFaq = function() {
        let faq = $(this);

        faq.addClass('open');

        faq.find('> .faq-content').stop().slideDown(200);
    };

    $.fn.closeFaq = function() {
        let faq = $(this);

        faq.removeClass('open');

        faq.find('> .faq-content').stop().slideUp(200);
    };
});